import urls from "../../../global/constants/UrlConstants";
import { AstroReportFilters } from "../../../models/interfaces";
import { getCallParams, makeCall, makeCallFile } from "../../../utils/service";

export const downloadTimeAnalysis = async (
  profileId: string,
  language: string,
) => {
  try {
    const body = {
      profileId: profileId,
      language: language,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCallFile(urls.timeAnalysis, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadProfessionAnalysis = async (
  profileId: string,
  language: string,
) => {
  try {
    const body = {
      profileId: profileId,
      language: language,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.professionAnalysis, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadTrueLookReport = async (
  profileId: string,
  language: string,
) => {
  try {
    const body = {
      profileId: profileId,
      language: language,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.trueLookReport, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadTrueTattooReport = async (
  profileId: string,
  language: string,
) => {
  try {
    const body = {
      profileId: profileId,
      language: language,
    };
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.trueTattooReport, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

/**
 * Starts the astrocartography report job. Like the True Look / True Tattoo
 * reports it returns straight away — the finished .docx shows up in the
 * my-reports list that this screen polls.
 */
export const downloadAstrocartographyReport = async (
  profileId: string,
  language: string,
  /** Region and map-style filters; every key is optional server-side. */
  filters: AstroReportFilters = {},
) => {
  try {
    const body: any = {
      profileId: profileId,
      language: language,
    };
    // Only send what the user actually chose — an omitted key means the
    // backend default (whole world, vector map).
    if (filters.continent) body.continent = filters.continent;
    if (filters.country) body.country = filters.country;
    if (filters.basemap) body.basemap = filters.basemap;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.astrocartographyReport, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

/** Continent / country / basemap lists that drive the report filter dialog. */
export const getAstrocartographyFocusOptions = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.astrocartographyFocusOptions,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getProfessionAnalysisReport = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.professionAnalysis}/my-reports`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
